var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.337,43.313c1.51,0,2.929-0.587,3.995-1.655c2.203-2.203,2.203-5.788,0-7.991c-1.066-1.067-2.485-1.655-3.995-1.655 c-1.509,0-2.928,0.587-3.995,1.655c-2.203,2.203-2.203,5.788,0,7.991C55.409,42.726,56.828,43.313,58.337,43.313z M57.17,36.496 c0.312-0.312,0.727-0.483,1.167-0.483c0.441,0,0.855,0.171,1.167,0.483c0.644,0.644,0.644,1.691,0,2.334 c-0.623,0.622-1.711,0.623-2.334,0c-0.312-0.312-0.483-0.727-0.483-1.167C56.687,37.222,56.858,36.808,57.17,36.496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.301,27.698c-0.775-0.774-1.841-1.159-2.936-1.065l-16.941,1.518c-0.859,0.077-1.668,0.455-2.278,1.065L23.943,51.419 c-0.697,0.696-1.081,1.622-1.081,2.607s0.384,1.911,1.08,2.606l15.425,15.426c0.719,0.718,1.662,1.077,2.606,1.077 c0.944,0,1.888-0.359,2.607-1.078l22.203-22.203c0.61-0.61,0.988-1.419,1.065-2.278l1.518-16.942 C69.464,29.543,69.075,28.473,68.301,27.698z M63.875,47.106L41.974,69.008L26.993,54.026l21.901-21.901l16.455-1.475 L63.875,47.106z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.981225cf61b4305e41e7ca10302127af.svg";
export { ForwardRef as ReactComponent };